import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=64aaf163&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports